var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "password-setting-panel" }, [
    _c("h2", { staticClass: "panel-title" }, [_vm._v("Update your password")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "password-setting-wrapper" },
      [
        _c("rt-input", {
          ref: "currPassword",
          staticClass: "password-input",
          attrs: {
            editType: "password",
            placeholder: "Current Password",
            floatingLabel: "Current Password",
            autocomplete: "off",
          },
          model: {
            value: _vm.currPassword,
            callback: function ($$v) {
              _vm.currPassword = $$v
            },
            expression: "currPassword",
          },
        }),
        _vm._v(" "),
        _c("rt-input", {
          ref: "newPassword",
          staticClass: "password-input",
          attrs: {
            type: "password",
            placeholder: "New Password",
            floatingLabel: "New Password",
            autocomplete: "off",
          },
          model: {
            value: _vm.newPassword,
            callback: function ($$v) {
              _vm.newPassword = $$v
            },
            expression: "newPassword",
          },
        }),
        _vm._v(" "),
        _c("rt-input", {
          ref: "confirmPassword",
          staticClass: "password-input",
          attrs: {
            type: "password",
            placeholder: "Confirm New Password",
            floatingLabel: "Confirm New Password",
            autocomplete: "off",
          },
          model: {
            value: _vm.confirmPassword,
            callback: function ($$v) {
              _vm.confirmPassword = $$v
            },
            expression: "confirmPassword",
          },
        }),
        _vm._v(" "),
        _vm.errorMessage
          ? _c("p", { staticClass: "submit-error" }, [
              _vm._v(_vm._s(_vm.errorMessage)),
            ])
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "setting-panel-footer" },
      [
        _c(
          "primary-button",
          {
            staticClass: "btn-close",
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          },
          [_vm._v("Close")]
        ),
        _vm._v(" "),
        _c(
          "primary-button",
          { staticClass: "btn-save", on: { click: _vm.handleUpdatePassword } },
          [_vm._v("Update Password")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }